<div mat-dialog-title class="dialog-title p-3 pr-5 clearfix">
  <h5>RBAC Roles</h5>

  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    (click)="onClose()"
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>

  <button
    *ngIf="canCreate"
    id="add"
    mat-raised-button
    color="primary"
    type="button"
    class="m-1 mr-2"
    (click)="onEditRbacRole()"
    matTooltip="Create a new RBAC role.">
    <mat-icon>add</mat-icon>
    New RBAC Role
  </button>

  <form class="form-inline my-2 my-xl-0 float-xl-right" (ngSubmit)="listDataSource.getData(true)">
    <input
      class="form-control mr-2 my-1"
      type="search"
      [(ngModel)]="listDataSource.search"
      name="search"
      placeholder="Search"
      aria-label="Search" />

    <button
      mat-raised-button
      color="secondary"
      class="mr-2 mr-xl-3 my-1"
      type="submit"
      matTooltip="Run the current search">
      <mat-icon>search</mat-icon> Search
    </button>

    <button mat-raised-button class="mr-2 my-1" (click)="onDeselectAllRecords()" type="button" [disabled]="listDataSource.selection.selected.length <= 0">
      Clear Selected
    </button>
  </form>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <table mat-table [dataSource]="listDataSource" matSort matSortActive="name" matSortDirection="asc" matSortDisableClear>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          (change)="$event ? onToggleSelectAllOnPage() : null"
          [checked]="listDataSource.selection.hasValue() && listDataSource.isAllSelected()"
          [indeterminate]="listDataSource.selection.hasValue() && !listDataSource.isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <!-- Locked partner roles keep their selection state and show a lock instead of a checkbox. -->
        @if (isLockedRow(row)) {
          <mat-icon class="align-middle" [matTooltip]="'Managed by ' + utils.getAppName()">lock</mat-icon>
        } @else {
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? onToggleRowSelection(row) : null"
            [checked]="listDataSource.selection.isSelected(row.id)">
          </mat-checkbox>
        }
      </td>
    </ng-container>

    <!-- ID Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
      <td mat-cell *matCellDef="let element">{{ element.id }}</td>
    </ng-container>

    <!-- Role Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Role Name</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>

    <ng-container matColumnDef="rbac_permissions_count">
      <th mat-header-cell *matHeaderCellDef matTooltip="The count of enabled permissions.">
        Permissions
      </th>
      <td mat-cell *matCellDef="let rbac_role">
        {{ rbac_role.rbac_permissions_count  }}
      </td>
    </ng-container>

    <ng-container matColumnDef="users_count">
      <th mat-header-cell *matHeaderCellDef [matTooltip]="'The count of associated ' + utils.getLangTerm('employees.plural', 'Employees').toLowerCase() + '.'">
        {{ utils.getLangTerm('employees.plural', 'Employees') }}
      </th>
      <td mat-cell *matCellDef="let rbac_role">
          <span style="text-decoration: underline;" [matTooltip]="getRoleUsersForTooltip(rbac_role)">
            {{ rbac_role.users_count  }}
          </span>
      </td>
    </ng-container>

    <!-- Created At / Date Created Column -->
    <ng-container matColumnDef="date_created">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Created At</th>
      <td mat-cell *matCellDef="let element">{{ (element.date_created * 1000) | timezoneConvertMedium }}</td>
    </ng-container>

    <!-- Updated At / Modified At Column -->
    <ng-container matColumnDef="date_modified">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Modified At</th>
      <td mat-cell *matCellDef="let element">{{ (element.date_modified * 1000) | timezoneConvertMedium }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="listColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: listColumns" (click)="onToggleRowSelection(row)"></tr>
  </table>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-end px-3 py-1">
  <mat-paginator
    class="my-2 ml-1 mr-2"
    #paginator
    [length]="listDataSource?.total | async"
    [pageSize]="listDataSource.limit"
    [pageSizeOptions]="listDataSource.pageSizeOptions"
    showFirstLastButtons>
  </mat-paginator>

  <button mat-button mat-raised-button class="my-2 ml-1 mr-2" color="primary" (click)="onSelectMultiple()" *ngIf="listDataSource.multiple">
    Select & Close
  </button>

  <button mat-button mat-raised-button class="my-2 mx-1" color="secondary" (click)="onSelectAllRecords()">
    Select All & Close ({{ listDataSource.allIds.length }})
  </button>
</mat-dialog-actions>
